module.exports = " <section class=news> <div class=news-list> <home-news-item :article=\"news[page * 2]\"></home-news-item> <home-news-item :article=\"news[page * 2 + 1]\"></home-news-item> </div> <span class=\"news-list__prev icon-arrow-left-green\" v-on:click=changeNewsPage(-1) v-if=\"page>0\"></span> <span class=\"news-list__next icon-arrow-right-green\" v-on:click=changeNewsPage(1) v-if=\"page<(news.length/2)-1\"></span> </section> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/home/HomeNews.vue
// module id = 191
// module chunks = 0